import { computed, Ref } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { MessageAttachment } from "@scrile/api-provider/dist/api/MessagesProvider";
import { isImageFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { MAIN_CONTAINER_WIDTH } from "@/const";

export default function useImageAttachment(attachment: Ref<MessageAttachment | FileData>, isFullScreen: Ref<boolean>) {
  const file = computed(() => ("file" in attachment.value ? attachment.value.file : attachment.value));
  const dpr = Math.floor(window.devicePixelRatio);
  const isImage = computed(() => isImageFile(file.value));
  const previewThumbnail = computed(() => {
    if (!isImage.value) return "";
    return MediaFilesController.getImageThumbnail(file.value.urlPart, MAIN_CONTAINER_WIDTH * dpr, 0, {
      exactSize: true,
    });
  });
  const fullScreenThumbnail = computed(() => {
    if (!isImage.value) return "";
    return MediaFilesController.getImageThumbnail(file.value.urlPart, "1080p");
  });
  const imageThumbnail = computed(() => (isFullScreen.value ? fullScreenThumbnail.value : previewThumbnail.value));

  return {
    isImage,
    imageThumbnail,
  };
}
